import { css, keyframes } from 'styled-components';

import fadeIn from 'react-animations/lib/fade-in';
import fadeOut from 'react-animations/lib/fade-out';

import zoomIn from 'react-animations/lib/zoom-in';
import bounceOut from 'react-animations/lib/bounce-out';

const fadeInAnimation = keyframes`${fadeIn}`;
const fadeOutAnimation = keyframes`${fadeOut}`;

const zoomInAnimation = keyframes`${zoomIn}`;
const bounceOutAnimation = keyframes`${bounceOut}`;

export const Wrapper = css`
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 105;
`;

export const Holder = css`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 20px;
  overflow: auto;
  background: ${(props) => props.theme.background};
  opacity: 0;

  ${(props) =>
    props.open &&
    css`
      opacity: 1;
      animation: ${fadeInAnimation} 0.2s;
    `}

  ${(props) =>
    props.close &&
    css`
      animation: ${fadeOutAnimation} 0.2s;
    `}

  &::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.thumb};
  }

  &::-webkit-scrollbar-track {
    background: ${(props) => props.theme.track};
  }
`;

export const Panel = css`
  position: relative;
  display: block;
  margin: auto;
  border-radius: 10px;
  background: ${(props) => props.theme.background};
  box-shadow: 0px 3px 6px 0px ${(props) => props.theme.shadow};
  opacity: 1;
  overflow: hidden;

  ${(props) =>
    props.open &&
    css`
      animation: ${zoomInAnimation} 0.2s;
    `}

  ${(props) =>
    props.close &&
    css`
      animation: ${bounceOutAnimation} 0.2s;
    `}

  ${(props) =>
    props.fullscreen &&
    css`
      height: 100%;
    `}
`;

export const Close = css`
  position: absolute;
  top: 20px;
  right: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 25px;
  height: 25px;
  color: ${(props) => props.theme.color};
  transition: 0.2s color;
  cursor: pointer;
  z-index: 101;

  &:hover {
    color: ${(props) => props.theme.colorOnHover};
  }
`;

export const CloseIcon = css`
  display: block;
  font-size: 22px;
  user-select: none;
`;

export const Content = css`
  display: block;
  width: 100%;

  ${(props) =>
    props.fullscreen &&
    css`
      height: 100%;
    `}
`;
